import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Kateryna Porshnieva
 * id 205A2FF1-8827-4D3D-8580-FF7FFCD5232C
 * name loading
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/loading.svg
 * tags
 */
export const LoadingIcon = createSvgIcon(<><path d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" /></>, 'LoadingIcon');
export default LoadingIcon